import { render, staticRenderFns } from "./mock-change-request-form.vue?vue&type=template&id=204f379d&scoped=true&"
import script from "./mock-change-request-form.vue?vue&type=script&lang=js&"
export * from "./mock-change-request-form.vue?vue&type=script&lang=js&"
import style0 from "./mock-change-request-form.vue?vue&type=style&index=0&id=204f379d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f379d",
  null
  
)

export default component.exports